/**
 * POST /api/v1/ticket and POST /api/v1/sales/ may return `shouldRegister` on the root JSON
 * or on `data` (aligned with the main app `processPaymentSaga` → `response.data.shouldRegister`).
 */
export function extractShouldRegister(payload: unknown): boolean | undefined {
  if (!payload || typeof payload !== 'object') return undefined;
  const p = payload as Record<string, unknown>;
  if (typeof p.shouldRegister === 'boolean') return p.shouldRegister;
  const d = p.data;
  if (d && typeof d === 'object') {
    const dr = d as Record<string, unknown>;
    if (typeof dr.shouldRegister === 'boolean') return dr.shouldRegister;
  }
  return undefined;
}
